export default "__VITE_ASSET__7c734858__"